module.exports = __webpack_public_path__ + "static/img/rank_350.f598880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_350.png
// module id = TPJH
// module chunks = 0